import React from 'react';
import {Provider} from 'mobx-react';


import Store from './Store';
import data from './data';

const store = new Store(data);

export default ({children}) => (
  <Provider albums={store.albums} photos={store.photos} testimonials={store.testimonials}>
    {children}
  </Provider>
);


/** WEBPACK FOOTER **
 ** ./src/StoreProvider.js
 **/